// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}
// TODO: REVISAR RUTAS
const ROOTS_AUTH = '/auth';
const ROOTS_WORKSPACE = '/workspace/:workspaceId';
const ROOTS_DEVICES = `${ROOTS_WORKSPACE}/devices`;
const ROOTS_CUSTOMERS = `${ROOTS_WORKSPACE}/customers`;
const ROOTS_PLACES = `${ROOTS_WORKSPACE}/places`;
const ROOTS_SERVICE_ORDERS = `${ROOTS_WORKSPACE}/service-orders`;
const ROOTS_INVOICES = `${ROOTS_WORKSPACE}/invoices`;
const ROOTS_SETTINGS = `${ROOTS_WORKSPACE}/settings`;
const ROOTS_DEVICE_PROFILE = `${ROOTS_WORKSPACE}/device/:deviceId`;
const ROOTS_MONITORING = `${ROOTS_WORKSPACE}/monitoring`;
const ROOTS_TRAFFIC = `${ROOTS_WORKSPACE}/traffic`;
const MONITORING_ROOTS_DEVICE_PROFILE = `${ROOTS_WORKSPACE}/monitoring/device/:deviceId`;
const EMERCENCY_CONTACT_LIST = `${ROOTS_WORKSPACE}/emergencyContactList/:emergencyContactListId`;
const ACTIONS = `${ROOTS_WORKSPACE}/actions/:actionGroupId`;
const ROOTS_REPORTS = `${ROOTS_WORKSPACE}/reports`;

// ----------------------------------------------------------------------
export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  register: path(ROOTS_AUTH, '/register'),
  forgotPassword: path(ROOTS_AUTH, '/forgot-password'),
};

export const PATH_PAGE = {
  page404: '/404',
  page500: '/500',
  resetpassword: '/reset-password',
  validateaccount: '/validate-account',
  logout: '/logout',
  createWorkspace: '/create-workspace',
  workspaceInvitation: '/workspace-invitation',
  customerInvitation: '/customer-invitation',
  workspaces: '/workspaces',
  customer: '/customer',
  customerDeviceProfile: '/customer/device/:deviceId',
};

// export const PATH_CUSTOMER = {
//   root: ROOTS_CUSTOMER,
//   dashboard: path(ROOTS_CUSTOMER, ''),
// };
export const PATH_WORKSPACE = {
  root: ROOTS_WORKSPACE,
  dashboard: path(ROOTS_WORKSPACE, '/dashboard'),
  monitoring: {
    root: ROOTS_MONITORING,
    eventsTable: path(ROOTS_MONITORING, '/eventsTable'),
  },
  traffic: {
    root: ROOTS_TRAFFIC,
  },
  devices: {
    root: ROOTS_DEVICES,
  },
  reports: {
    root: ROOTS_REPORTS,
    devicesByEvent: path(ROOTS_REPORTS, '/devices-by-event'),
    devicesByActivity: path(ROOTS_REPORTS, '/devices-by-activity'),
    devicesByLastEvent: path(ROOTS_REPORTS, '/devices-by-last-event'),
    devicesWithoutImage: path(ROOTS_REPORTS, '/devices-without-image'),
    devicesByLastPosition: path(ROOTS_REPORTS, '/devices-by-last-position'),
    devicesWithoutPlace: path(ROOTS_REPORTS, '/devices-without-place'),
  },
  places: {
    root: ROOTS_PLACES,
  },
  serviceOrders: {
    root: ROOTS_SERVICE_ORDERS,
  },
  invoices: {
    root: ROOTS_INVOICES,
    profile: `${ROOTS_INVOICES}/:invoiceId`,
  },
  customers: {
    root: ROOTS_CUSTOMERS,
    profile: `${ROOTS_CUSTOMERS}/:customerId`,
  },
  deviceProfile: (fromMonitoring) => ({
    root: fromMonitoring
      ? MONITORING_ROOTS_DEVICE_PROFILE
      : ROOTS_DEVICE_PROFILE,
    events: path(MONITORING_ROOTS_DEVICE_PROFILE, '/events'),
    general: path(
      fromMonitoring ? MONITORING_ROOTS_DEVICE_PROFILE : ROOTS_DEVICE_PROFILE,
      '/general'
    ),
    zones: path(
      fromMonitoring ? MONITORING_ROOTS_DEVICE_PROFILE : ROOTS_DEVICE_PROFILE,
      '/zones'
    ),
    users: path(
      fromMonitoring ? MONITORING_ROOTS_DEVICE_PROFILE : ROOTS_DEVICE_PROFILE,
      '/users'
    ),
    map: path(
      fromMonitoring ? MONITORING_ROOTS_DEVICE_PROFILE : ROOTS_DEVICE_PROFILE,
      '/map'
    ),
    history: path(
      fromMonitoring ? MONITORING_ROOTS_DEVICE_PROFILE : ROOTS_DEVICE_PROFILE,
      '/history'
    ),
    notes: path(
      fromMonitoring ? MONITORING_ROOTS_DEVICE_PROFILE : ROOTS_DEVICE_PROFILE,
      '/notes'
    ),
    emergencyContact: path(
      fromMonitoring ? MONITORING_ROOTS_DEVICE_PROFILE : ROOTS_DEVICE_PROFILE,
      '/emergencyContact'
    ),
    rounds: path(
      fromMonitoring ? MONITORING_ROOTS_DEVICE_PROFILE : ROOTS_DEVICE_PROFILE,
      '/rounds'
    ),
  }),
  users: path(ROOTS_WORKSPACE, '/users'),
  emergencyContactList: EMERCENCY_CONTACT_LIST,
  actions: ACTIONS,
  settings: {
    root: ROOTS_SETTINGS,
    general: path(ROOTS_SETTINGS, '/general'),
    integrations: path(ROOTS_SETTINGS, '/integrations'),
    users: path(ROOTS_SETTINGS, '/users'),
    roles: path(ROOTS_SETTINGS, '/roles'),
    eventGroups: path(ROOTS_SETTINGS, '/eventGroups'),
    events: path(ROOTS_SETTINGS, '/events'),
    notificationGroups: path(ROOTS_SETTINGS, '/notificationGroups'),
    models: path(ROOTS_SETTINGS, '/models'),
    brands: path(ROOTS_SETTINGS, '/brands'),
    resolutions: path(ROOTS_SETTINGS, '/resolutions'),
    actions: path(ROOTS_SETTINGS, '/actions'),
    items: path(ROOTS_SETTINGS, '/items'),
    plans: path(ROOTS_SETTINGS, '/plans'),
    invoiceSeries: path(ROOTS_SETTINGS, '/invoice-series'),
    emergencyContacts: path(ROOTS_SETTINGS, '/emergencyContacts'),
    emergencyContactLists: path(ROOTS_SETTINGS, '/emergencyContactLists'),
  },
};

export const PATH_PROFILE = {
  root: '/profile',
};

// Admin Mode Routes
const ROOTS_ADMIN = '/admin';

export const PATH_ADMIN = {
  root: ROOTS_ADMIN,
  workspaces: path(ROOTS_ADMIN, '/workspaces'),
  workspaceProfile: path(ROOTS_ADMIN, '/workspaces/:workspaceId'),
  users: path(ROOTS_ADMIN, '/users'),
  integrations: path(ROOTS_ADMIN, '/integrations'),
};
